import { render, staticRenderFns } from "./modal-delete-role.vue?vue&type=template&id=39208b0c&scoped=true&"
import script from "./modal-delete-role.vue?vue&type=script&lang=js&"
export * from "./modal-delete-role.vue?vue&type=script&lang=js&"
import style0 from "./modal-delete-role.vue?vue&type=style&index=0&id=39208b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39208b0c",
  null
  
)

export default component.exports